import { useAppSelector } from "lib/store";
import useMount from "react-use/lib/useMount";
import ModalTitle from "../ModalTitle";
import { getActiveNotificationsMessagesById } from "_slices/notifications";
import globalStyles from '../modal.module.css';
import styles from './agentContact.module.css'

import { useNotificationLocation } from "lib/hooks/useNotificationLocation";

import logRepContact from "lib/ga/repContact"
import Contact from "../Contact";

type Props = {
    title: string,
    subTitle: string,
    property: Property,
    user: {
        forename: string;
        surname: string;
        email: string;
        telephone: string;
        company: {
            name: string;
        };
    },
    agent: {
        forename: string,
        surname: string,
        id: string,
        user_id: string
    },
    agentCompany?: {
        logo_uri: string,
        name: string
    } | null,
    id?: string,
    type?: string,
    closeModal: any
}

type Property = {
    name: string;
    type: string;
    id: string;
    hasBid: boolean;
    address: {
        line2: string;
        line1: string;
        postcode: string;
        town_name: string;
        firstLine:string;
        secondLine:string;
    };
}

const AgentContact = ({ title, subTitle, property, user, closeModal, agent, agentCompany, id, type }: Props) => {
    title = title || "Schedule a Call";
    subTitle = subTitle || "";

    let notification_id = 'MODAL_PROPERTY_CONTACT_FORM_AGENT';
    const [sendSuccess, activeNotifications] = useNotificationLocation(notification_id);

    useMount(() => {
        // Log that the modal has been opened and how is being contacted
        logRepContact({
            type: "email",
            state: "opened",
            target: agent.id,
            id: id,
            subject_type: type
        })
    })

    return <>
        <ModalTitle title={title} containerMargin="1rem" />
        {!sendSuccess && activeNotifications &&
            activeNotifications.map((id) => {
                return <NotificationMessage key={id} id={id} />;
            })}
        <div className="largeText boldText"  style={{
            marginBottom: '1rem'
        }}>Send a message to {`${agent.forename} ${agent.surname}`}</div>

        {agentCompany && agentCompany.logo_uri && <div className={styles.AgentsLogoContainer}>

            <div className={styles.AgentsLogo}>
                <img alt={`${agentCompany.name} logo`} src={process.env.NEXT_PUBLIC_APP_MEDIA_URL + agentCompany.logo_uri}></img>
            </div>

        </div>}
        <div className={styles.PropertyContainer}>
            <div>{property.name}</div>
            <div>{property.address.firstLine ? property.address.firstLine : property.address.line1}, {property.address.secondLine ? property.address.secondLine : property.address.line2}</div>
        </div>

        <div className={styles.FormTitle}>
            Send A Message
        </div>
        <Contact googleCat='Agent Contact' googleType='local_agents' property={property} user={user} agentList={[]} closeModal={closeModal} agentId={agent.id ? agent.id : agent.user_id} />
    </>
}

export default AgentContact;


interface NotificationMessageProps {
    id: string
}
const NotificationMessage = ({ id }: NotificationMessageProps) => {
    let messages = useAppSelector((state) => getActiveNotificationsMessagesById(id, state));

    return <div className={globalStyles.AlertDanger} key={id}>
        {messages.map((message) => {
            return <div key={id}>{message}</div>;
        })}
    </div>
}
